// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KEFW_","label":"styles_label__1GbkB"};